import type { ExpertReviewStatus } from '@repo/shared'

/** 전문가 검수 상태 이름 (관리자 화면 전용, 한국어) */
export const EXPERT_REVIEW_STATUS_LABEL: Record<ExpertReviewStatus, string> = {
  requested: '요청됨',
  in_progress: '진행 중',
  completed: '완료',
  rejected: '반려',
}
